import { render, staticRenderFns } from "./CompanyDBSSection.vue?vue&type=template&id=e26cda38&scoped=true"
import script from "./CompanyDBSSection.vue?vue&type=script&lang=js"
export * from "./CompanyDBSSection.vue?vue&type=script&lang=js"
import style0 from "./CompanyDBSSection.vue?vue&type=style&index=0&id=e26cda38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26cda38",
  null
  
)

export default component.exports